import React from 'react';

import { useDispatch, useSelector } from 'react-redux';
import Auth from '../../auth/authWindow';
import { toggleAuthWindow } from '../../store/schemas/authSlice';
const NetworkButton = ({children, classes}) => {
    const dispatch = useDispatch();
    const connected = useSelector(state => state.mainapp.authSlice.metamask.connected);
    const chainMatch = useSelector(state => state.mainapp.authSlice.metamask.chainMatch);



    return (
        <>  

      
            {
                connected ? 
                    chainMatch ? 
                        children 
                    : 
                    <button type='button' onClick={() => { dispatch(toggleAuthWindow())}} className={classes}>Confirm Network</button> 
                : 
                <button type='button' onClick={() => { dispatch(toggleAuthWindow())}} className={classes}>Connect Wallet</button>
            }
          

      
        </>
    );
};

export default NetworkButton;
